export const modal = `<div class="modal active">
    <div class="content">

        <div class="header">
            <p>Modal title</p>
            <div class="close" id="modal-close">×</div>
        </div>

        <div class="body">
            ...write any content here
        </div>

        <div class="footer">
            <p>Modal footer</p>
        </div>

    </div>
</div>`

export const modalTop = `<div class="modal top0">
    <div class="content">

        <div class="header">
            <div class="close" id="modal-close">×</div>
            <p>Modal title</p>
        </div>

        <div class="body">
            ...write any content here
        </div>

        <div class="footer">
            <p>Modal footer</p>
        </div>

    </div>
</div>`

export const modalScroll = `<div class="modal scroll">
    <div class="content">

        <div class="header">
            <div class="close" id="modal-close">×</div>
            <p>Modal title</p>
        </div>

        <div class="body">
            ...write a very long content here
        </div>

        <div class="footer">
            <p>Modal footer</p>
        </div>

    </div>
</div>`